import { fg } from '@atlassian/jira-feature-gating';

export default {
	get(): boolean {
		return fg('jsm_portal_rovo_agent_config_experience');
	},
};
